import React, { useEffect, useRef, useState } from "react";
import { SubjectIcon } from "../../../../../SubjectIcon";
import axios from "../../../../../axios";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SubjectBox = ({ filter }) => {
  const [summeryCard, setSummeryCard] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -400, behavior: "smooth" });
  };

  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsOverflowing(container.scrollWidth > container.clientWidth);
    }
  };

  useEffect(() => {
    const handleResize = () => checkOverflow();
    // Delay checking to wait for DOM rendering
    const timer = setTimeout(() => checkOverflow(), 200);

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [summeryCard]);

  useEffect(() => {
    let Teacher_id = localStorage.getItem("Teacher_id");
    let Teacher_Json = JSON.parse(Teacher_id);

    const timetableSessionId = localStorage.getItem("timeTableSessionId");
    const academicSessionId = localStorage.getItem("academicYearSessionId");
    const academic_Json = JSON.parse(academicSessionId);
    const timeTable_Json = JSON.parse(timetableSessionId);

    const helper = async () => {
      try {
        setLoading(true);
        let response = await axios.get(
          `/api/v1/homework/preRead/teacherSummary/get/teacherId/${Teacher_Json}?academicSessionId=${academic_Json}&timetableSessionId=${timeTable_Json}&standardId=${filter.standard_id}&sectionId=${filter.section_id}`,
        );
        setSummeryCard(response.data.data || []);
      } catch (error) {
        console.error("Error fetching subject summary:", error);
      } finally {
        setLoading(false);
      }
    };

    if (Teacher_Json !== null) {
      helper();
    }
  }, [filter.standard_id, filter.section_id]);

  return (
    <div
      className="publish_summery_container gap-3 mb-2 mt-2"
      style={{
        width: "auto",
        backgroundColor: "#f2f2f2",
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      {loading ? (
        <div className="text-center w-100 py-4">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          ref={scrollContainerRef}
          className="publish_summery_container mb-4 gap-3 d-flex position-relative"
          style={{
            overflowX: "auto",
            scrollBehavior: "smooth",
            alignItems: "center",
            position: "relative",
            minHeight: "150px", // keeps layout stable while loading
          }}
        >
          {/* Left Sticky Button */}
          {isOverflowing && (
            <button
              type="button"
              className="btn btn-light d-flex align-items-center justify-content-center shadow"
              onClick={scrollLeft}
              style={{
                position: "sticky",
                left: 0,

                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "50%",
                backgroundColor: "#FDEFE3",
                width: "40px",
                height: "40px",
                border: "1px solid #4B4B4B",
              }}
            >
              <ChevronLeft color="#4B4B4B" size={24} />
            </button>
          )}

          {/* Cards or Loader */}
          {summeryCard.map((summery, index) => (
            <div
              key={index}
              className="py-1 px-3 text-center shadow-sm rounded-4 mb-1"
              style={{
                minWidth: "250px",
                maxWidth: "350px",
                backgroundColor: "#FDEFE3",
                borderTop: "2px solid #8D4B28",
                borderRight: "4px solid #8D4B28",
                borderBottom: "1px solid #8D4B28",
                borderLeft: "1px solid #8D4B28",
                borderRadius: "0.75rem",
              }}
            >
              <div className="d-flex flex-column align-items-center mb-1">
                <img
                  src={
                    SubjectIcon?.find(
                      (i) => i.subjectName === summery?.subject?.name,
                    )?.icon || "/subIcon/ic_png_science.png"
                  }
                  alt=""
                  style={{ height: "32px" }}
                />
                <h6
                  className="mt-1 fw-bold text-brown mx-auto text-truncate poppins-semibold"
                  title={summery?.subject?.name}
                  style={{
                    maxWidth: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "#8D4B28",
                  }}
                >
                  {summery?.subject?.name}
                </h6>
              </div>

              <div className="d-flex justify-content-around gap-2 border-top pt-2 text-muted small fw-semibold">
                <div className="d-flex flex-column">
                  <small className="text-sm poppins-semibold">
                    Not started
                  </small>
                  <small className="text-dark poppins-semibold">
                    {summery?.not_started > 0
                      ? String(summery?.not_started).padStart(2, "0")
                      : "0"}
                  </small>
                </div>

                <div
                  className="mx-2"
                  style={{
                    width: "2px",
                    backgroundColor: "#333",
                    opacity: 0.5,
                  }}
                ></div>

                <div className="d-flex flex-column px-3">
                  <small className="text-nowrap poppins-semibold">Draft</small>
                  <small className="text-dark poppins-semibold">
                    {summery?.on_review > 0
                      ? String(summery?.on_review).padStart(2, "0")
                      : "0"}
                  </small>
                </div>
              </div>
            </div>
          ))}

          {/* Right Sticky Button */}
          {isOverflowing && (
            <button
              type="button"
              className="btn btn-light d-flex align-items-center justify-content-center shadow"
              onClick={scrollRight}
              style={{
                position: "sticky",
                right: 0,
                zIndex: 0,
                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "50%",
                backgroundColor: "#FDEFE3",
                width: "40px",
                height: "40px",
                border: "1px solid #4B4B4B",
              }}
            >
              <ChevronRight color="#4B4B4B" size={24} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SubjectBox;
